import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ServicePlanAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ServicePlanAppIcon';

const ServiceAgreementsStrategy = {
  previewInfo: {
    name: 'Service plans',
    iconSvg: <ServicePlanAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Service plans',
    category: 'Automate billing and manage your Service Agreements + Memberships',
    details: (
      <div>
        Service plans allow you to offer your customers an ongoing maintenance plan that’s convenient for both you and
        your customer. Having customers on service plans lets you build customer loyalty and automate repeat business.
        <br /> <br />
      </div>
    ),
    iconSvg: <ServicePlanAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/czg8h98enl?videoFoam=true',
  },
  sellingPoints: {
    headline: 'With Service plans, you’ll be able to',
    description: '',
    unorderedPoints: [
      'Create, track, and manage maintenance plans',
      'Drive recurring dependable revenue set up on a monthly, 6 month, or yearly billing cycle',
      'Know when your customers are due for another service or renewal',
      'Create advanced reports on recurring and projected revenue',
    ],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Housecall Pro Add-on Price',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $40/month
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $40/month
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $0/month
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    showBetaButton: false,
  },
  supportContacts: [],
};

export default ServiceAgreementsStrategy;
